import { ProductDatesFilter } from '../../types/models/product/product-date'

export const transformProductDateFiltersToUrl = (filters?: ProductDatesFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.years && filters.years.length) searchParams.append('years', filters.years.join(','))
  if (filters.options && filters.options.length)
    searchParams.append('options', filters.options.join(','))
  if (filters.mainOptions && filters.mainOptions.length)
    searchParams.append('mainOptions', filters.mainOptions.join(','))
  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))
  if (filters.tripIds && filters.tripIds.length)
    searchParams.append('tripIds', filters.tripIds.join(','))
  if (filters.journeyPlaces && filters.journeyPlaces.length)
    searchParams.append('journeyPlaces', filters.journeyPlaces.join(','))
  if (filters.productId) searchParams.append('productId', filters.productId.toString())
  if (filters.durationInDays)
    searchParams.append('durationInDays', filters.durationInDays.toString())
  if (filters.locked) searchParams.append('locked', filters.locked.toString())
  if (filters.published) searchParams.append('published', filters.published.toString())

  return searchParams.toString()
}

export const transformUrlToProductDateFilters = (
  searchParams: URLSearchParams
): ProductDatesFilter => {
  const filters: ProductDatesFilter = {}

  const years = searchParams.get('years')
  if (years && years.length) filters.years = years.split(',').map(Number)

  const options = searchParams.get('options')
  if (options && options.length) filters.options = options.split(',')

  const mainOptions = searchParams.get('mainOptions')
  if (mainOptions && mainOptions.length) filters.mainOptions = mainOptions.split(',')

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')

  const tripIds = searchParams.get('tripIds')
  if (tripIds && tripIds.length) filters.tripIds = tripIds.split(',').map(Number)

  const journeyPlaces = searchParams.get('journeyPlaces')
  if (journeyPlaces && journeyPlaces.length) filters.journeyPlaces = journeyPlaces.split(',')

  const productId = searchParams.get('productId')
  if (productId) filters.productId = +productId

  const durationInDays = searchParams.get('durationInDays')
  if (durationInDays) filters.durationInDays = +durationInDays

  const locked = searchParams.get('locked')
  if (locked) filters.locked = locked === 'true'

  const published = searchParams.get('published')
  if (published) filters.published = published === 'true'

  return filters
}

export const productDateFilterMapping: Record<keyof ProductDatesFilter, string> = {
  durationInDays: 'Durée en jours',
  years: 'Année',
  productId: 'Produit',
  options: 'Option',
  mainOptions: 'Option principale',
  periods: 'Période',
  tripIds: 'Voyage',
  journeyPlaces: 'Lieu de voyage',
  locked: 'Verrouillé',
  published: 'Publié'
}
